import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BillingState {
  searchTerm: string;
}

const initialState: BillingState = {
  searchTerm: '',
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload.trim();
    },
  },
});

export const { setSearchTerm } = billingSlice.actions;

export default billingSlice.reducer;
